




























import { Component, Prop, Vue } from 'vue-property-decorator';
import { Organisation, OrganisationType } from '@/api';

@Component({})
export default class SubscriptionPortalBanner extends Vue {
  @Prop({ required: true }) readonly organisation: Organisation;

  get conditionalTitle() {
    if (
      [OrganisationType.None, OrganisationType.Trial].includes(
        this.organisation.orgType,
      )
    ) {
      return 'Manage';
    }
    return 'View';
  }

  get manageLink() {
    const geccoOrgId = this.organisation.geccoOrgId || '';
    const portalUrl = this.$t('common.geccoOrgUrl');
    return `${portalUrl}/${geccoOrgId}`;
  }
}
